const ResgisterApiClient = {
  register: "/live_session/register/",
};

export default ResgisterApiClient;
